import styled from '@emotion/styled'

import Mailbox from './Mailbox'

export default styled(Mailbox)`
  &&& {
    color: ${props => props.theme.color.primary.brand};
  }
`
